module.exports = __webpack_public_path__ + "static/media/website-11.fed3999a.png";